module.exports = __webpack_public_path__ + "static/media/logo.30ab1a21.svg";